/**
 * Ícone de presente no header: leva para a página de Novidades e mostra
 * quantas entregas a pessoa ainda não viu.
 */
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import { Rocket } from "lucide-react";

export default function WhatsNewButton() {
  const navigate = useNavigate();
  const [unseen, setUnseen] = useState(0);

  const carregar = useCallback(() => {
    api
      .get("/changelog?resumo=true")
      .then(({ data }) => setUnseen(data.unseen || 0))
      .catch(() => setUnseen(0));
  }, []);

  useEffect(() => {
    carregar();
    const zerar = () => setUnseen(0);
    window.addEventListener("changelog-seen", zerar);
    return () => window.removeEventListener("changelog-seen", zerar);
  }, [carregar]);

  return (
    <button
      type="button"
      onClick={() => navigate("/whats-new")}
      className="relative p-2 rounded-lg hover:bg-gray-100 transition-colors"
      title="Novidades do sistema"
      data-testid="header-whats-new-btn"
    >
      <Rocket size={20} className="text-gray-500" />
      {unseen > 0 && (
        <span
          className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 rounded-full bg-[#ff9945] text-white text-[10px] font-bold flex items-center justify-center"
          data-testid="whats-new-badge"
        >
          {unseen > 9 ? "9+" : unseen}
        </span>
      )}
    </button>
  );
}
